module.exports = __webpack_public_path__ + "img/2048-small.34d438c5.svg";